export default __webpack_public_path__ + "static/media/europe_circle.1dedea30.svg";